const permisos = process.env.VUE_APP_URL_API;
//const permisos = "http://localhost:8000";

const axiosConfigSendFile = (containToken = true) => {
    const config = {
        headers: {
            'Content-type': 'multipart/form-data'
            , 'Accept': 'application/vnd.api+json'
            , 'Access-Control-Allow-Origin': '*'
            , 'Access-Control-Allow-Headers': '*'
            , 'cache-control': 'no-cache'
            , 'Authorization': '',
        }
    }
    if (containToken && localStorage.getItem('token') != null) config.headers.Authorization = 'Bearer ' + localStorage.getItem('token')
    return config
}


export default {
    permisosURL: permisos,
    permisosApi: permisos + '/api/',
    axiosConf: (token, response_type = "") => {
        const config = {
            headers: {
                'Content-type': 'multipart; form-data; application/json; charset=utf-8',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET',
                'Access-Control-Allow-Headers': '*',
                'cache-control': 'no-cache',
                'Authorization': '',
            }
        }
        if (token && localStorage.getItem('token') != null) {
            config.headers.Authorization = 'Bearer ' + localStorage.getItem('token');
        }
        const type = {
            arraybuffer: 'arraybuffer',
            document: 'document',
            text: 'text',
            stream: 'stream',
            blob: 'blob'
        }
        if (type[response_type]) { config.responseType = type[response_type] }
        return config;
    }
    , axiosConfigSendFile
}
    
